module.exports = __webpack_public_path__ + "static/media/syllIcon.1c955ea5.png";